import { Component, OnInit } from '@angular/core';

import { AccommodationService } from '../../accommodation.service';

@Component({
	selector: 'app-accommodation-list-products',
	templateUrl: './accommodation-list-products.component.html',
	styleUrls: ['./accommodation-list-products.component.css'],
})
export class AccommodationListProductsComponent implements OnInit {
	protected products = [];
	protected selected = [];

	constructor(public service: AccommodationService) {}

	ngOnInit(): void {
		this.products = [...this.service.productsAll];
		this.selected = [...this.service.productsSelected];
	}

	protected applyfilter(filterValue: string): void {
		this.products = this.service.productsAll
			.filter((item) => item.name.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase()))
			.slice();
	}

	protected change(product) {
		const index = this.selected.indexOf(product.id);
		if (index == -1) {
			this.selected.push(product.id);
			return;
		}
		this.selected.splice(index, 1);
	}

	protected selectAll(): void {
		this.products.forEach((product) => {
			if (this.selected.indexOf(product.id) == -1) {
				this.selected.push(product.id);
			}
		});
	}
}
